import { useNavigate, } from 'react-router-dom';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { alpha, } from '@mui/material/styles';
import { useApp, useAppbar, useAuth, } from '../../../hooks';
import CustomLink from '../../custom-link';

const ListPages = () => {
    const { newFolderModalOpen, } = useApp();
    const { drawerMenuClose, } = useAppbar();
    const { user, } = useAuth();

    const navigate = useNavigate();

    return (
        <List
            disablePadding
            sx={[
                {
                    '& .MuiListItem-root': {
                        cursor: 'pointer',
                        '&:hover': {
                            bgcolor: 'transparent',
                            '.MuiSvgIcon-root, .MuiListItemText-root': {
                                color: 'secondary.main',
                            },
                        },
                        '&:active': {
                            bgcolor: (theme) => alpha(
                                theme.palette.text.secondary,
                                theme.palette.action.selectedOpacity,
                            ),
                        },
                    },
                    '& .MuiLink-root': {
                        border: 0,
                        borderRadius: 0,
                        fontSize: 14,
                        p: 0,
                        width: '100%',
                    },
                    '& .MuiListItemText-root': {
                        fontSize: 14,
                    },
                    '& .MuiListItemIcon-root': {
                        minWidth: 'auto',
                        mt: '-2px',
                        mr: 1.5,
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: 20,
                    }
                },
            ]}>
            <ListItem
                onClick={drawerMenuClose}
                onKeyDown={drawerMenuClose}
                disablePadding
                disableGutters sx={{mb: 0.5,}}>
                <CustomLink
                    to='/set/create'
                    variant='btn'>
                    <ListItemIcon>
                        <AutoAwesomeMotionIcon />
                    </ListItemIcon>
                    <ListItemText disableTypography>Сет карточек</ListItemText>
                </CustomLink>
            </ListItem>
            <ListItem
                onClick={() => {
                    drawerMenuClose();
                    (user) ? newFolderModalOpen() : navigate('/login');
                }}
                onKeyDown={drawerMenuClose}
                disablePadding
                disableGutters>
                <ListItemIcon>
                    <CreateNewFolderIcon />
                </ListItemIcon>
                <ListItemText disableTypography>Папка</ListItemText>
            </ListItem>
        </List>
    );
};

export default function AccordionCreate({ sx = [], ...props}) {
    const { accordionCreateIsOpen, accordionCreateToggle, } = useAppbar();

    return (
        <Accordion
            disableGutters
            elevation={0}
            expanded={accordionCreateIsOpen}
            onChange={() => accordionCreateToggle()}
            sx={[
                {
                    '&::before': {
                        display: 'none',
                    },
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
            { ...props }>
            <AccordionSummary expandIcon={<ExpandMoreIcon  sx={{ color: 'text.primary', }} />}>
                <Typography sx={{ color: 'text.primary', fontSize: 14, }}>Создать</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: 1, borderColor: 'borderColor.main', py: 1.5, }}>
                <ListPages />
            </AccordionDetails>
        </Accordion>
    )
};